import { camelCase } from 'lodash';
import * as R from 'ramda';

/**
 * Возвращает массив id из prop объекта data
 * data: { prop: [{id: 1}, {id: 2}] } => [1,2]
 * */
const getAllIdsByProp = (prop, data) => {
  if (R.isNil(R.prop(prop, data))) return;

  return R.compose(
    R.map(R.toString),
    R.pluck('id'),
    R.view(R.lensProp(prop))
  )(data);
};

/**
 * Возвращает нормализированный объект из массива
 * data: [{id: 1}] => {byId: {1: {id: 1}}, allIds: [1]}
 */
const normalizeChildData = data => {
  return R.applySpec({
    byId: R.pipe(R.groupBy(R.prop('id')), R.map(R.head)),
    allIds: R.pluck('id'),
  })(data);
};

/**
 * TODO: Дописать хелпер по нормализации объекта с ключами camelCase и обработкой children
 * data: {id: 1, prop_names: [{id: 11}]} => {id: 1, propNames: [11]}
 */
const normalizeParentData = (prop, data) => {
  return R.compose(
    R.assoc(prop),
    R.map(R.toString),
    R.pipe(R.view(R.lensProp(prop)), R.pluck('id')),
    R.fromPairs,
    R.map(R.adjust(0, camelCase)),
    R.toPairs
  )(data)(data);
};

export { getAllIdsByProp, normalizeChildData, normalizeParentData };
